import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ConfirmEmailModalComponent } from './modal/confirm-email-modal.component';
import { NotifyService, VendorAPI } from 'sustainment-component';

@Component({
  selector: 'app-supplier-email-confirmation',
  templateUrl: './supplier-email-confirmation.component.html',
  styleUrls: ['./supplier-email-confirmation.component.scss'],
  providers: [DialogService],
  standalone: false
})
export class SupplierEmailConfirmationComponent {
  @Input() public vendorLogo: string;
  @Input() public vendorName: string;
  @Input() public supplierEmail: string;
  @Input() public vendorSustainmentId: string;

  @Output() public vendorClicked = new EventEmitter<void>();
  @Output() public emailConfirmed = new EventEmitter<{
    hasConfirmedEmail: boolean;
    email: string;
  }>();

  public isConfirmingEmail: boolean;

  public constructor(
    private _dialogService: DialogService,
    private _vendorApi: VendorAPI,
    private _notifyService: NotifyService
  ) {}

  public vendorClick(event: Event): void {
    event.stopPropagation();
    this.vendorClicked.emit();
  }

  public confirmEmail(event: Event): void {
    event.preventDefault();

    this.isConfirmingEmail = true;

    this._vendorApi.confirmSupplierEmail(this.vendorSustainmentId).subscribe(
      () => {
        this.isConfirmingEmail = false;
        this._notifyService.showSuccess(
          'Supplier record has been confirmed',
          'Success'
        );
        this.emailConfirmed.emit({
          email: this.supplierEmail,
          hasConfirmedEmail: true
        });
      },
      (err) => {
        this._notifyService.showDanger(err.error.message);
        this.isConfirmingEmail = false;
      }
    );
  }

  public openConfirmationModal(event: Event): void {
    event.preventDefault();

    const ref = this._dialogService.open(ConfirmEmailModalComponent, {
      data: {
        supplierEmail: this.supplierEmail,
        vendorSustainmentId: this.vendorSustainmentId
      },
      showHeader: true,
      header: 'Confirm supplier email'
    });

    ref.onClose.subscribe((result) => {
      if (result?.hasConfirmedEmail) {
        this.emailConfirmed.emit(result);
      }
    });
  }
}
